import { Fragment } from 'react'
import Image from 'next/image'

import { RedTesting, useExperiment } from 'rvbr-www/red-testing'

import { Anchor, Container, If, Loader, Proposal } from '@/components'

import { ANCHORS, HERO_IMAGES, HERO_TEXTS } from './constants'

import styles from './Hero.module.scss'

const HeroTexts = ({ variant }) => {
  return (
    <div className={styles.hero__content}>
      <h1 className={styles.hero__title}>{HERO_TEXTS[variant].title}</h1>
      <h2 className={styles.hero__subtitle}>{HERO_TEXTS[variant].subtitle}</h2>
    </div>
  )
}

export const Hero = ({ variant }) => {
  const { successfulExperiment } = useExperiment('hero_form_cards')

  return (
    <section className={`${styles.hero} ${styles[`hero--${variant}`]}`}>
      <Container classname={styles.hero__container}>
        <Image
          fill
          priority
          sizes="100vw"
          placeholder="blur"
          className={styles.hero__background}
          src={HERO_IMAGES[variant]}
          alt="homem e mulher sorrindo enquanto olham para um notebook"
        />

        <div className={styles.hero__wrapper}>
          <HeroTexts variant={variant} />

          <If
            condition={variant === 'home'}
            renderIf={
              <RedTesting
                loader={<Loader customClass={styles.hero__loader} />}
                experimentId="hero_form_cards"
                control={
                  <div className={styles.hero__proposal}>
                    <Proposal />
                  </div>
                }
                variants={[<Fragment key="hero_form_cards--a" />]}
              />
            }
            renderElse={
              <div className={styles.hero__proposal}>
                <Proposal />
              </div>
            }
          />
        </div>

        <If condition={variant === 'home'}>
          <RedTesting
            experimentId="hero_form_cards"
            control={<></>}
            variants={[
              <div key="hero_form_cards--b" className={styles.hero__anchors}>
                {ANCHORS.map(({ id, icon, badge_text, text, url, target }) => (
                  <Anchor
                    tagName="a"
                    id={id}
                    key={id}
                    href={url}
                    target={target}
                    icon={icon}
                    text={<b>{text}</b>}
                    badgeText={badge_text}
                    onClick={() => successfulExperiment()}
                  />
                ))}
              </div>
            ]}
          />
        </If>
      </Container>
    </section>
  )
}
